import script from "./TaskDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskDetails.vue?vue&type=script&setup=true&lang=js"

import "./TaskDetails.vue?vue&type=style&index=0&id=126397e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-126397e8"]])

export default __exports__